export const ACCENT_MAP = {
  coral: { bg: "#FF6B6B", text: "#FF6B6B" },
  teal: { bg: "#2DD4BF", text: "#2DD4BF" },
  purple: { bg: "#A855F7", text: "#A855F7" },
  amber: { bg: "#F59E0B", text: "#F59E0B" },
  rose: { bg: "#F43F5E", text: "#F43F5E" },
  emerald: { bg: "#10B981", text: "#10B981" },
  blue: { bg: "#3B82F6", text: "#3B82F6" },
  pink: { bg: "#EC4899", text: "#EC4899" },
};

export const accentHex = (key) => (ACCENT_MAP[key] && ACCENT_MAP[key].bg) || "#94A3B8";

export const STATUS_TONE = {
  "Not contacted": "text-aot-muted border-aot-border",
  "Email sent": "text-aot-blue border-aot-blue/60",
  "Chaser sent": "text-aot-amber border-aot-amber/60",
  "Replied": "text-aot-teal border-aot-teal/60",
  "Call scheduled": "text-aot-purple border-aot-purple/60",
  "Interested": "text-aot-teal border-aot-teal/60",
  "Deal closed": "text-aot-emerald border-aot-emerald/60",
  "Not interested": "text-aot-muted border-aot-subtle",
  "Unsubscribed": "text-aot-rose border-aot-rose/60",
};

export const formatRelative = (iso) => {
  if (!iso) return "Never run";
  const then = new Date(iso).getTime();
  const diff = Date.now() - then;
  if (Number.isNaN(then)) return "Never run";
  const sec = Math.floor(diff / 1000);
  if (sec < 60) return `${sec}s ago`;
  const min = Math.floor(sec / 60);
  if (min < 60) return `${min}m ago`;
  const hr = Math.floor(min / 60);
  if (hr < 48) return `${hr}h ago`;
  const day = Math.floor(hr / 24);
  if (day < 14) return `${day}d ago`;
  return new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric" });
};
